import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { EventType, PublicClientApplication } from '@azure/msal-browser';
import { isRedirectBridgePath, runRedirectBridge } from './redirectBridge';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './authConfig';
import { initTheme } from './utils/theme';
import { initProjectTheme } from './utils/projectTheme';
import { initFavicon } from './utils/favicon';
import { appConfig } from './utils/appConfig';
import { initAppInsights } from './utils/appInsights';

// Set document title from appConfig
document.title = appConfig.projectName;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
// MSAL v5 redirect bridge: when the auth response lands on the bridge path
// (popup, silent-iframe, or full-redirect flow), relay it to the opener over a
// BroadcastChannel and close. This MUST run before PublicClientApplication /
// MsalProvider initialize — otherwise MSAL would consume the response first.
if (isRedirectBridgePath()) {
  root.render(
    <React.StrictMode>
      <p>Processing authentication…</p>
    </React.StrictMode>
  );
  runRedirectBridge();
} else {
  const msalInstance = new PublicClientApplication(msalConfig);

  // ✅ Async initialization
  msalInstance.initialize().then(() => {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
      msalInstance.setActiveAccount(accounts[0]); // ✅ ensure AuthenticatedTemplate works after reload
    }

    // ✅ Set active account after successful login
    msalInstance.addEventCallback((event: any) => {
      if (event.eventType === EventType.LOGIN_SUCCESS && event.payload?.account) {
        const account = event.payload.account;
        msalInstance.setActiveAccount(account);
      }
    });

    // ✅ Initialize theme synchronously before rendering
    initTheme();
    initAppInsights();

    // ✅ Initialize project theme (CMS/RMS) and favicon
    const projectTheme = initProjectTheme();
    initFavicon(projectTheme);

    // ✅ Render only after MSAL is ready
    root.render(
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </React.StrictMode>
    );

  }).catch((err) => {
    console.error("MSAL initialization failed:", err);
  });
}

reportWebVitals();
